var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#FFEDD9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1066_4289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.875 16.4242V16.4194L28.4304 18.0118L32 16.6735L22.5 13.111L13 16.6735L22.5 20.236L26.0554 18.9025L22.5 17.4371V17.4335L24.875 16.4242Z",
    fill: "#FF8900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17.861V28.5485L21.9062 31.889V21.2015L13 17.861ZM17.75 28.5877L15.375 27.6971V26.43L17.75 27.3207V28.5877Z",
    fill: "#FF8900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 19.197V22.1717L26.0625 23.0623V20.0876L23.0938 21.2015V31.889L32 28.5485V17.861L28.4375 19.197Z",
    fill: "#FF8900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1066_4289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsSold);
export default __webpack_public_path__ + "static/media/Products Sold.0bda89b68ef655cd0e329034e6cbb9bf.svg";
export { ForwardRef as ReactComponent };